import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { hi as f, fi as n, M as o } from "./abstract-base-8edf0a84-e11d45a3.js";
var h = Object.defineProperty,
  u = Object.getOwnPropertyDescriptor,
  i = function i(p, t, s, r) {
    for (var e = r > 1 ? void 0 : r ? u(t, s) : t, c = p.length - 1, a; c >= 0; c--) (a = p[c]) && (e = (r ? a(t, s, e) : a(e)) || e);
    return r && e && h(t, s, e), e;
  };
var l = /*#__PURE__*/function (_f) {
  _inherits(l, _f);
  function l() {
    var _this;
    _classCallCheck(this, l);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments)), _this.index = 0, _this.label = "", _this.color = "", _this.value = "";
    return _this;
  }
  return l;
}(f(n));
i([o({
  reflect: !0
})], l.prototype, "index", 2);
i([o({
  reflect: !0
})], l.prototype, "label", 2);
i([o({
  reflect: !0
})], l.prototype, "color", 2);
i([o({
  reflect: !0
})], l.prototype, "value", 2);
export { l as s };